var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_869_1190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C2.05502 8.30104 3.97811 7.39792 5.44359 5.94359C6.89792 4.47811 7.80104 2.55502 8 0.5C8.19896 2.55502 9.10208 4.47811 10.5564 5.94359C12.0219 7.39792 13.945 8.30104 16 8.5C13.9429 8.69125 12.0173 9.59553 10.5564 11.0564C9.09553 12.5173 8.19125 14.4429 8 16.5C7.80104 14.445 6.89792 12.5219 5.44359 11.0564C3.97811 9.60208 2.05502 8.69896 0 8.5Z",
    fill: "#1BC29A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_1190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicGreen);
export default __webpack_public_path__ + "static/media/MagicGreen.ea5244d0f8e09fd66d8f6e95ca55a875.svg";
export { ForwardRef as ReactComponent };